'use client';

import { c as _c } from "react/compiler-runtime";
import type { PrivacyFieldProps } from '@/app/components/form-kit/types';
import { Checkbox } from '@/app/components/forms/checkbox';
import { Link } from '@/app/components/navigation/link';
import { Tooltip } from '@/app/components/overlays/tooltip';
import { FORM_MESSAGES } from '@/app/constants/forms';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
import { safeCall } from '@/app/utils/safeCall';
const EVENT_NAME = 'privacy-policy-click';
export const PrivacyField = t0 => {
  const $ = _c(38);
  const {
    theme: t1,
    checked: t2,
    isOpen: t3,
    isError: t4,
    isLoading: t5,
    children,
    requiredMessage,
    tracking,
    tooltipClassName,
    className,
    onClose,
    onChange,
    registerRef
  } = t0;
  const theme = t1 === undefined ? "light" : t1;
  const checked = t2 === undefined ? false : t2;
  const isOpen = t3 === undefined ? false : t3;
  const isError = t4 === undefined ? false : t4;
  const isLoading = t5 === undefined ? false : t5;
  let t6;
  if ($[0] !== tooltipClassName) {
    t6 = cn("w-full py-3", tooltipClassName);
    $[0] = tooltipClassName;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const t7 = requiredMessage ?? `กรุณากดยอมรับ <span>${FORM_MESSAGES.privacyPolicy}</span>`;
  let t8;
  if ($[2] !== onClose) {
    t8 = () => safeCall(onClose);
    $[2] = onClose;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  let t9;
  if ($[4] !== registerRef) {
    t9 = registerRef?.("privacy");
    $[4] = registerRef;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  let t10;
  if ($[6] !== onChange) {
    t10 = e => safeCall(onChange, e.target.checked);
    $[6] = onChange;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const t11 = !!isError;
  let t12;
  if ($[8] !== className) {
    t12 = cn("items-start", className);
    $[8] = className;
    $[9] = t12;
  } else {
    t12 = $[9];
  }
  const t13 = tracking?.eventName ?? EVENT_NAME;
  let t14;
  if ($[10] !== t13 || $[11] !== tracking) {
    t14 = {
      ...tracking,
      eventName: t13
    };
    $[10] = t13;
    $[11] = tracking;
    $[12] = t14;
  } else {
    t14 = $[12];
  }
  let t15;
  if ($[13] !== children || $[14] !== isLoading || $[15] !== theme || $[16] !== tracking?.eventName) {
    t15 = children ?? <>{FORM_MESSAGES.acceptPrivacy}{" "}<Link href="/privacy-policy" theme={theme} className={cn({
        "pointer-events-none text-gray-300": isLoading
      })} target="_blank" onClick={_temp} {...createDataAttributes({
        test: "privacy-field"
      })} {...createDataGA({
        eventName: tracking?.eventName ?? EVENT_NAME,
        group: "privacy-field",
        click: true,
        text: FORM_MESSAGES.privacyPolicy,
        url: "/privacy-policy"
      })}>{FORM_MESSAGES.privacyPolicy}</Link></>;
    $[13] = children;
    $[14] = isLoading;
    $[15] = theme;
    $[16] = tracking?.eventName;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== t15) {
    t16 = <span className="where-span:text-inline-wrap min-w-0 flex-1">{t15}</span>;
    $[18] = t15;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== checked || $[21] !== t16) {
    t17 = [{
      name: "privacy",
      checked,
      children: t16
    }];
    $[20] = checked;
    $[21] = t16;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== isLoading || $[24] !== t10 || $[25] !== t11 || $[26] !== t12 || $[27] !== t14 || $[28] !== t17 || $[29] !== t9 || $[30] !== theme) {
    t18 = <Checkbox ref={t9} theme={theme} name="privacy" onChangeInput={t10} error={t11} disabled={isLoading} className={t12} tracking={t14} options={t17} />;
    $[23] = isLoading;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
    $[27] = t14;
    $[28] = t17;
    $[29] = t9;
    $[30] = theme;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== isOpen || $[33] !== t18 || $[34] !== t6 || $[35] !== t7 || $[36] !== t8) {
    t19 = <Tooltip manualShow={true} wrapperClassName={t6} tooltipClassName="where-span:inline-block w-auto" theme="dark" placement="top-left" arrowCenter={false} show={isOpen} text={t7} onClose={t8}>{t18}</Tooltip>;
    $[32] = isOpen;
    $[33] = t18;
    $[34] = t6;
    $[35] = t7;
    $[36] = t8;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  return t19;
};
function _temp(e_0) {
  return e_0.stopPropagation();
}